import { GearSix, House, ListBullets, Plus, TrendUp } from '@phosphor-icons/react';
import { lazy, Suspense } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { SyncIndicator } from '../components/SyncIndicator';
import styles from './AppShell.module.css';

const QuickEntryDialog = lazy(() => import('../components/QuickEntryDialog').then((module) => ({ default: module.QuickEntryDialog })));

const navigation = [
  { to: '/', label: 'Início', icon: House, end: true },
  { to: '/lancamentos', label: 'Lançamentos', icon: ListBullets, end: false },
  { to: '/relatorios', label: 'Relatórios', icon: TrendUp, end: false },
  { to: '/ajustes', label: 'Ajustes', icon: GearSix, end: false }
] as const;

export function AppShell() {
  const [entryOpen, setEntryOpen] = useState(false);
  const [entryLoaded, setEntryLoaded] = useState(false);
  const location = useLocation();
  const openEntry = () => { setEntryLoaded(true); setEntryOpen(true); };
  useEffect(() => { window.addEventListener('kemi:new-entry', openEntry); return () => window.removeEventListener('kemi:new-entry', openEntry); }, []);
  return (
    <div className={styles.shell}>
      <a className={styles.skipLink} href="#conteudo">Pular para o conteúdo</a>
      <aside className={styles.sidebar} aria-label="Navegação principal">
        <div className={styles.brand}><span className={styles.logo}>K</span><span><strong>KemiControl</strong><small>Finanças sem ruído</small></span></div>
        <nav>
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => isActive ? styles.activeLink : styles.navLink}>
              <Icon size={22} weight="duotone" /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <button className={styles.desktopAdd} type="button" onClick={openEntry}><Plus size={20} weight="bold" /> Novo lançamento</button>
        <SyncIndicator compact={false} />
      </aside>
      <div className={styles.workspace}>
        <header className={styles.mobileHeader}>
          <span className={styles.mobileBrand}><span className={styles.logo}>K</span><strong>KemiControl</strong></span>
          <SyncIndicator compact />
        </header>
        <main id="conteudo" key={location.pathname} className={styles.content}><Outlet /></main>
      </div>
      <nav className={styles.bottomNav} aria-label="Navegação principal">
        {navigation.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => isActive ? styles.activeBottom : styles.bottomLink}>
            <Icon size={24} weight="duotone" /><span>{label}</span>
          </NavLink>
        ))}
      </nav>
      {entryLoaded && <Suspense fallback={null}><QuickEntryDialog open={entryOpen} onClose={() => setEntryOpen(false)} /></Suspense>}
    </div>
  );
}
